import { ModalContainer, Page, useModel, useRoute } from "@bcm-dev/bcms-vite";
import Util from 'classes/Util';
import modals from "components/custom-ui/CustomModal/components";
import React, { useEffect, useState } from 'react';
import "./styles.css";
/**
 * @function PageContainer
 * @param {STRING} className - Additional CSS class name that's pass to the component.
 * @param {React.Component} children - Content that's contained in this page.
 * @returns {React.Component}
 * @example
 * <PageContainer className="some-class">
 *  <h1>Page content</h1>
 * </PageContainer>
 */
export default function PageContainer(props) {
  const navigate = useRoute();
  let className = props.className ?? "";
  const onClickProp = props.onClick instanceof Function ? { onClick: props.onClick } : {};
  const ignoreTrigger = props.ignoreTrigger ?? false;
  const model = useModel();
  const { branding } = model;
  const { options } = branding;
  const customFont = options.custom_font_abi22;
  let customFontClass = "";
  const hasCustomFont = customFont === "undefined" || customFont === "Default" ? false : true;

  if(hasCustomFont) {
    customFontClass = `${ customFont.toLowerCase() }-font`;
    className = `${ className } ${ customFontClass }`;
  }
  
  window.addEventListener("message", evt => {
   if(evt.data.message === "force-global-route"){
    const { route, state } = evt.data.detail;

    navigate(route, { state: state ?? {} });
   }
    
  });
  

    window.parent.postMessage({ message: "abi22-iframe-did-load", abi22Branding: model.branding }, "*");


  useEffect(() => {
    // Send a message to MABI23 that this iframe loaded.

    try {
      if (window.parent) {
          
        if (window.parent.document) {
          if (window.parent.document.loadFrame && !ignoreTrigger) {
            window.parent.document.loadFrame();
  
          }
        }
      }
    }
    catch (error) {

    }
  
  }, []);

  return(
    <Page className={className+ (!Util.inMabi?" abi-page":" mabi-page" )} isActive="false" state={ props.state } controller={ props.controller }>
      <ModalContainer modals={ modals }>
        <div className="page-container flex-container flex-vertical" { ...onClickProp }>
          {props.children}
        </div>
      </ModalContainer>
    </Page>
  );
}
